import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import './RangeSlider.css';
import { ScaleTypes } from '../../stores/discharge-store';

const defaultStyles = {
  root: {
    color: '#95a9b5',
    height: 10,
    width: 300,
  },
  thumb: {
    height: '24px',
    width: '24px',
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: '-8px',
    marginLeft: '-12px',
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
    fontSize: '16px',
  },
  track: {
    height: 10,
  },
  rail: {
    height: 10,
  },
};

const aggScaleStyles = {
  root: {
    color: '#bca68e',
  },
};

const cemScaleStyles = {
  root: {
    color: '#95a9b5',
  },
};

const waterScaleStyles = {
  root: {
    color: '#55b5f1',
  },
};

const ScaleAggSlider = withStyles({...defaultStyles, ...aggScaleStyles})(Slider);
const ScaleCemSlider = withStyles({...defaultStyles, ...cemScaleStyles})(Slider);
const ScaleWaterSlider = withStyles({...defaultStyles, ...waterScaleStyles})(Slider);

export default function RangeSlider({type, range = [0, 100], id, isPrimary = false, onChange = () => {}}) {
  return (
    <div>
      {type === ScaleTypes.AGG && (
        <ScaleAggSlider
          disabled={!!isPrimary}
          step={1}
          min={0}
          max={100}
          value={range}
          onChange={onChange}
          valueLabelDisplay="auto"
          aria-labelledby={`range-slider-${id}`}
        />
      )}
      {(!type || type === ScaleTypes.CEM) && (
        <ScaleCemSlider
          disabled={!!isPrimary}
          step={1}
          min={0}
          max={100}
          value={range}
          onChange={onChange}
          valueLabelDisplay="auto"
          aria-labelledby={`range-slider-${id}`}
        />
      )}
      {type === ScaleTypes.WATER && (
        <ScaleWaterSlider
          disabled={!!isPrimary}
          step={1}
          min={0}
          max={100}
          value={range}
          onChange={onChange}
          valueLabelDisplay="auto"
          aria-labelledby={`range-slider-${id}`}
        />
      )}

    </div>
  );
}
